import React from "react";
// COMPONENTS
import SelectProtocolType from "../select/SelectProtocolType";

export default function FormSelectProtocolTypeEmun({
	value,
	onChangeProtocolTypeEnum,
	disabledInput,
}: {
	value: string;
	onChangeProtocolTypeEnum: (newValue: string) => void;
	disabledInput: boolean;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeInputProtocolEnum = (newValue: string) => {
		onChangeProtocolTypeEnum(newValue);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>Protocol Name</span>
				</div>
				<div className='generalStyles__width100'>
					<SelectProtocolType
						value={value}
						onChangeProtocolType={onChangeInputProtocolEnum}
						disabledInput={disabledInput}
					/>
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}
